define([
  'es6!sumo/util',
  'immutable',
  'underscore',
  'es6!launcher/actions/DisplayRuleActions',
], (Util, Immutable, _, Actions) => {
  const initialState = Immutable.Map({
    list: Immutable.List(),
  });

  const actionHandlers = {};

  actionHandlers[Actions.RECEIVE_DISPLAY_RULE_SETS] = (state, action) =>
    state.set('list', Immutable.fromJS(action.displayRuleSets));

  actionHandlers[Actions.RECEIVE_DISPLAY_RULE_SET] = (state, action) => {
    const { displayRuleSet } = action;
    const list = state.get('list');
    let newList = list;

    // wipe an existing set with the same name if needed
    const listJS = newList.toJS();
    const displayRuleSetName = displayRuleSet.name.trim().toLowerCase();
    const existingSet = _.find(listJS, set => set.name.trim().toLowerCase() === displayRuleSetName);
    const index = _.indexOf(listJS, existingSet);

    if (existingSet) {
      newList = newList.delete(index);
    }

    // now push the new set
    newList = newList.push(Immutable.fromJS(displayRuleSet));

    return state.set('list', newList);
  };

  actionHandlers[Actions.DELETE_DISPLAY_RULE_SET] = (state, action) => {
    const list = state.get('list');
    const index = list.toJS().map(o => o.id).indexOf(action.displayRuleSet.id);
    let newList = list;

    if (index >= 0) {
      newList = newList.delete(index);
    }
    return state.set('list', newList);
  };

  return Util.createReducer(initialState, actionHandlers);
});
